import { render, staticRenderFns } from "./TheModalIndicacion.vue?vue&type=template&id=8c5c2074&scoped=true&"
import script from "./TheModalIndicacion.vue?vue&type=script&lang=js&"
export * from "./TheModalIndicacion.vue?vue&type=script&lang=js&"
import style0 from "./TheModalIndicacion.vue?vue&type=style&index=0&id=8c5c2074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c2074",
  null
  
)

export default component.exports